import React from "react";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import DashboardIcon from "@mui/icons-material/Dashboard";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";

const contractorDashboardNav = [
  {
    key: "overview",
    label: "Overview",
    description: "Dashboard summary",
    icon: <DashboardIcon fontSize="small" />,
  },
  {
    key: "opportunities",
    label: "Opportunities",
    description: "Hire invitations",
    icon: <MailOutlineIcon fontSize="small" />,
  },
  {
    key: "work",
    label: "Work",
    description: "Timesheets and summaries",
    icon: <WorkOutlineIcon fontSize="small" />,
  },
  {
    key: "earnings",
    label: "Earnings",
    description: "Balance and payouts",
    icon: <AccountBalanceWalletIcon fontSize="small" />,
  },
  {
    key: "billing",
    label: "Billing",
    description: "Invoices and payments",
    icon: <ReceiptLongIcon fontSize="small" />,
  },
];

export default contractorDashboardNav;

